/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Connection_Settings_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Spaces_Connection_Settings_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_remove = /** @type {((inputs: Spaces_Connection_Settings_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} entfernen`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
});